import GLOBAL from '../actions/global'
import { ErrorSwallow } from '../../lib/errors'

const initialState = {
  loadingCount: 0,
  loadError: null,
  serverError: null,
  currentSite: 'internal',
}

const getters = {
  globalLoading: state => state.loadingCount > 0,
  serverError: state => state.serverError,
  loadError: state => state.loadError,
  currentSite: state => state.currentSite,
}

const actions = {
  [GLOBAL.LOADING]: ({ commit }, callbacks) => {
    const callback = callbacks.callback || callbacks
    const { onLoadError } = callbacks
    commit(GLOBAL.LOADING)
    return callback()
      .then(() => commit(GLOBAL.LOADED))
      .catch(response => {
        commit(GLOBAL.LOADED)
        if (response && response.errors) {
          onLoadError ? onLoadError(response.errors) : commit(GLOBAL.LOAD_ERROR, response.errors)
        } else if (!response || response instanceof XMLHttpRequest) {
          commit(GLOBAL.SERVER_ERROR, response)
        } else {
          if (!(response instanceof ErrorSwallow)) throw response
        }
      })
  },

  [GLOBAL.SERVER_ERROR]: ({ commit }, error) => {
    commit(GLOBAL.SERVER_ERROR, error)
  },

  [GLOBAL.LOAD_ERROR]: ({ commit }, error) => {
    commit(GLOBAL.LOAD_ERROR, error)
  },

  [GLOBAL.NAVIGATE_FROM_EXT]: ({ commit }, route) => {
    commit(GLOBAL.NAVIGATE_FROM_EXT, route)
    commit(GLOBAL.CURRENT_SITE, 'internal')
  },

  [GLOBAL.NAVIGATE_TO_EXT]: ({ commit }) => {
    // commit(GLOBAL.NAVIGATE_TO_EXT)
    commit(GLOBAL.CURRENT_SITE, 'external')
  },
}

const mutations = {
  [GLOBAL.LOADING]: state => {
    state.loadingCount += 1
  },

  [GLOBAL.LOADED]: state => {
    state.loadingCount -= 1
  },

  [GLOBAL.LOAD_ERROR]: (state, error) => {
    state.loadError = error
  },

  [GLOBAL.SERVER_ERROR]: (state, response) => {
    state.serverError = response
  },

  [GLOBAL.NAVIGATE_FROM_EXT]: (state, route) => {
    state.navigateFromExt = route
  },

  [GLOBAL.CURRENT_SITE]: (state, site) => {
    state.currentSite = site
  },
}

export default {
  state: initialState,
  getters,
  actions,
  mutations,
}
